import React from "react";
export default function FontsList({ botSettings, setFont, InputStlye, value }) {
    return (<div className="mb-1 text-center">
        <select
            name="Font Name"
            type='select'
            style={InputStlye}
            defaultValue={value}
            onChange={(e) => setFont(e)}
        >

            <option value='Academy Engraved LET' style={{ fontFamily: 'Academy Engraved LET' }}>Academy Engraved LET </option>

            <option value='AcademyEngravedLetPlain' style={{ fontFamily: 'AcademyEngravedLetPlain' }}>AcademyEngravedLetPlain </option>

            <option value='Al Nile' style={{ fontFamily: 'Al Nile' }}>Al Nile </option>

            <option value='AlNile-Bold' style={{ fontFamily: 'AlNile-Bold' }}>AlNile-Bold </option>

            <option value='American Typewriter' style={{ fontFamily: 'American Typewriter' }}>American Typewriter </option>

            <option value='AmericanTypewriter-Bold' style={{ fontFamily: 'AmericanTypewriter-Bold' }}>AmericanTypewriter-Bold </option>

            <option value='AmericanTypewriter-Condensed' style={{ fontFamily: 'AmericanTypewriter-Condensed' }}>AmericanTypewriter-Condensed </option>

            <option value='AmericanTypewriter-CondensedBold' style={{ fontFamily: 'AmericanTypewriter-CondensedBold' }}>AmericanTypewriter-CondensedBold </option>

            <option value='AmericanTypewriter-CondensedLight' style={{ fontFamily: 'AmericanTypewriter-CondensedLight' }}>AmericanTypewriter-CondensedLight </option>

            <option value='AmericanTypewriter-Light' style={{ fontFamily: 'AmericanTypewriter-Light' }}>AmericanTypewriter-Light </option>

            <option value='Apple Color Emoji' style={{ fontFamily: 'Apple Color Emoji' }}>Apple Color Emoji </option>

            <option value='Apple SD Gothic Neo' style={{ fontFamily: 'Apple SD Gothic Neo' }}>Apple SD Gothic Neo </option>

            <option value='AppleColorEmoji' style={{ fontFamily: 'AppleColorEmoji' }}>AppleColorEmoji </option>

            <option value='AppleSDGothicNeo-Bold' style={{ fontFamily: 'AppleSDGothicNeo-Bold' }}>AppleSDGothicNeo-Bold </option>

            <option value='AppleSDGothicNeo-Light' style={{ fontFamily: 'AppleSDGothicNeo-Light' }}>AppleSDGothicNeo-Light </option>

            <option value='AppleSDGothicNeo-Medium' style={{ fontFamily: 'AppleSDGothicNeo-Medium' }}>AppleSDGothicNeo-Medium </option>

            <option value='AppleSDGothicNeo-Regular' style={{ fontFamily: 'AppleSDGothicNeo-Regular' }}>AppleSDGothicNeo-Regular </option>

            <option value='AppleSDGothicNeo-SemiBold' style={{ fontFamily: 'AppleSDGothicNeo-SemiBold' }}>AppleSDGothicNeo-SemiBold </option>

            <option value='AppleSDGothicNeo-Thin' style={{ fontFamily: 'AppleSDGothicNeo-Thin' }}>AppleSDGothicNeo-Thin </option>

            <option value='AppleSDGothicNeo-UltraLight' style={{ fontFamily: 'AppleSDGothicNeo-UltraLight' }}>AppleSDGothicNeo-UltraLight </option>

            <option value='Arial' style={{ fontFamily: 'Arial' }}>Arial </option>

            <option value='Arial Hebrew' style={{ fontFamily: 'Arial Hebrew' }}>Arial Hebrew </option>

            <option value='Arial Rounded MT Bold' style={{ fontFamily: 'Arial Rounded MT Bold' }}>Arial Rounded MT Bold </option>

            <option value='Arial-BoldItalicMT' style={{ fontFamily: 'Arial-BoldItalicMT' }}>Arial-BoldItalicMT </option>

            <option value='Arial-BoldMT' style={{ fontFamily: 'Arial-BoldMT' }}>Arial-BoldMT </option>

            <option value='Arial-ItalicMT' style={{ fontFamily: 'Arial-ItalicMT' }}>Arial-ItalicMT </option>

            <option value='ArialHebrew' style={{ fontFamily: 'ArialHebrew' }}>ArialHebrew </option>

            <option value='ArialHebrew-Bold' style={{ fontFamily: 'ArialHebrew-Bold' }}>ArialHebrew-Bold </option>

            <option value='ArialHebrew-Light' style={{ fontFamily: 'ArialHebrew-Light' }}>ArialHebrew-Light </option>

            <option value='ArialMT' style={{ fontFamily: 'ArialMT' }}>ArialMT </option>

            <option value='ArialRoundedMTBold' style={{ fontFamily: 'ArialRoundedMTBold' }}>ArialRoundedMTBold </option>

            <option value='Avenir' style={{ fontFamily: 'Avenir' }}>Avenir </option>

            <option value='Avenir Next' style={{ fontFamily: 'Avenir Next' }}>Avenir Next </option>

            <option value='Avenir Next Condensed' style={{ fontFamily: 'Avenir Next Condensed' }}>Avenir Next Condensed </option>

            <option value='Avenir-Black' style={{ fontFamily: 'Avenir-Black' }}>Avenir-Black </option>

            <option value='Avenir-BlackOblique' style={{ fontFamily: 'Avenir-BlackOblique' }}>Avenir-BlackOblique </option>

            <option value='Avenir-Book' style={{ fontFamily: 'Avenir-Book' }}>Avenir-Book </option>

            <option value='Avenir-BookOblique' style={{ fontFamily: 'Avenir-BookOblique' }}>Avenir-BookOblique </option>

            <option value='Avenir-Heavy' style={{ fontFamily: 'Avenir-Heavy' }}>Avenir-Heavy </option>

            <option value='Avenir-HeavyOblique' style={{ fontFamily: 'Avenir-HeavyOblique' }}>Avenir-HeavyOblique </option>

            <option value='Avenir-Light' style={{ fontFamily: 'Avenir-Light' }}>Avenir-Light </option>

            <option value='Avenir-LightOblique' style={{ fontFamily: 'Avenir-LightOblique' }}>Avenir-LightOblique </option>

            <option value='Avenir-Medium' style={{ fontFamily: 'Avenir-Medium' }}>Avenir-Medium </option>

            <option value='Avenir-MediumOblique' style={{ fontFamily: 'Avenir-MediumOblique' }}>Avenir-MediumOblique </option>

            <option value='Avenir-Oblique' style={{ fontFamily: 'Avenir-Oblique' }}>Avenir-Oblique </option>

            <option value='Avenir-Roman' style={{ fontFamily: 'Avenir-Roman' }}>Avenir-Roman </option>

            <option value='AvenirNext-Bold' style={{ fontFamily: 'AvenirNext-Bold' }}>AvenirNext-Bold </option>

            <option value='AvenirNext-BoldItalic' style={{ fontFamily: 'AvenirNext-BoldItalic' }}>AvenirNext-BoldItalic </option>

            <option value='AvenirNext-DemiBold' style={{ fontFamily: 'AvenirNext-DemiBold' }}>AvenirNext-DemiBold </option>

            <option value='AvenirNext-DemiBoldItalic' style={{ fontFamily: 'AvenirNext-DemiBoldItalic' }}>AvenirNext-DemiBoldItalic </option>

            <option value='AvenirNext-Heavy' style={{ fontFamily: 'AvenirNext-Heavy' }}>AvenirNext-Heavy </option>

            <option value='AvenirNext-HeavyItalic' style={{ fontFamily: 'AvenirNext-HeavyItalic' }}>AvenirNext-HeavyItalic </option>

            <option value='AvenirNext-Italic' style={{ fontFamily: 'AvenirNext-Italic' }}>AvenirNext-Italic </option>

            <option value='AvenirNext-Medium' style={{ fontFamily: 'AvenirNext-Medium' }}>AvenirNext-Medium </option>

            <option value='AvenirNext-MediumItalic' style={{ fontFamily: 'AvenirNext-MediumItalic' }}>AvenirNext-MediumItalic </option>

            <option value='AvenirNext-Regular' style={{ fontFamily: 'AvenirNext-Regular' }}>AvenirNext-Regular </option>

            <option value='AvenirNext-UltraLight' style={{ fontFamily: 'AvenirNext-UltraLight' }}>AvenirNext-UltraLight </option>

            <option value='AvenirNext-UltraLightItalic' style={{ fontFamily: 'AvenirNext-UltraLightItalic' }}>AvenirNext-UltraLightItalic </option>

            <option value='AvenirNextCondensed-Bold' style={{ fontFamily: 'AvenirNextCondensed-Bold' }}>AvenirNextCondensed-Bold </option>

            <option value='AvenirNextCondensed-BoldItalic' style={{ fontFamily: 'AvenirNextCondensed-BoldItalic' }}>AvenirNextCondensed-BoldItalic </option>

            <option value='AvenirNextCondensed-DemiBold' style={{ fontFamily: 'AvenirNextCondensed-DemiBold' }}>AvenirNextCondensed-DemiBold </option>

            <option value='AvenirNextCondensed-DemiBoldItalic' style={{ fontFamily: 'AvenirNextCondensed-DemiBoldItalic' }}>AvenirNextCondensed-DemiBoldItalic </option>

            <option value='AvenirNextCondensed-Heavy' style={{ fontFamily: 'AvenirNextCondensed-Heavy' }}>AvenirNextCondensed-Heavy </option>

            <option value='AvenirNextCondensed-HeavyItalic' style={{ fontFamily: 'AvenirNextCondensed-HeavyItalic' }}>AvenirNextCondensed-HeavyItalic </option>

            <option value='AvenirNextCondensed-Italic' style={{ fontFamily: 'AvenirNextCondensed-Italic' }}>AvenirNextCondensed-Italic </option>

            <option value='AvenirNextCondensed-Medium' style={{ fontFamily: 'AvenirNextCondensed-Medium' }}>AvenirNextCondensed-Medium </option>

            <option value='AvenirNextCondensed-MediumItalic' style={{ fontFamily: 'AvenirNextCondensed-MediumItalic' }}>AvenirNextCondensed-MediumItalic </option>

            <option value='AvenirNextCondensed-Regular' style={{ fontFamily: 'AvenirNextCondensed-Regular' }}>AvenirNextCondensed-Regular </option>

            <option value='AvenirNextCondensed-UltraLight' style={{ fontFamily: 'AvenirNextCondensed-UltraLight' }}>AvenirNextCondensed-UltraLight </option>

            <option value='AvenirNextCondensed-UltraLightItalic' style={{ fontFamily: 'AvenirNextCondensed-UltraLightItalic' }}>AvenirNextCondensed-UltraLightItalic </option>


            <option value='Baskerville' style={{ fontFamily: 'Baskerville' }}>Baskerville </option>

            <option value='Baskerville-Bold' style={{ fontFamily: 'Baskerville-Bold' }}>Baskerville-Bold </option>

            <option value='Baskerville-BoldItalic' style={{ fontFamily: 'Baskerville-BoldItalic' }}>Baskerville-BoldItalic </option>

            <option value='Baskerville-Italic' style={{ fontFamily: 'Baskerville-Italic' }}>Baskerville-Italic </option>

            <option value='Baskerville-SemiBold' style={{ fontFamily: 'Baskerville-SemiBold' }}>Baskerville-SemiBold </option>

            <option value='Baskerville-SemiBoldItalic' style={{ fontFamily: 'Baskerville-SemiBoldItalic' }}>Baskerville-SemiBoldItalic </option>

            <option value='Bodoni 72 ' style={{ fontFamily: 'Bodoni 72' }}>Bodoni 72 </option>

            <option value='Bodoni 72 Oldstyle' style={{ fontFamily: 'Bodoni 72 Oldstyle' }}>Bodoni 72 Oldstyle </option>

            <option value='Bodoni 72 Smallcaps' style={{ fontFamily: 'Bodoni 72 Smallcaps' }}>Bodoni 72 Smallcaps </option>

            <option value='Bodoni Ornaments' style={{ fontFamily: 'Bodoni Ornaments' }}>Bodoni Ornaments </option>

            <option value='BodoniOrnamentsITCTT' style={{ fontFamily: 'BodoniOrnamentsITCTT' }}>BodoniOrnamentsITCTT </option>

            <option value='BodoniSvtyTwoITCTT-Bold' style={{ fontFamily: 'BodoniSvtyTwoITCTT-Bold' }}>BodoniSvtyTwoITCTT-Bold </option>

            <option value='BodoniSvtyTwoITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoITCTT-Book' }}>BodoniSvtyTwoITCTT-Book </option>

            <option value='BodoniSvtyTwoITCTT-BookIta' style={{ fontFamily: 'BodoniSvtyTwoITCTT-BookIta' }}>BodoniSvtyTwoITCTT-BookIta </option>

            <option value='BodoniSvtyTwoOSITCTT-Bold' style={{ fontFamily: 'BodoniSvtyTwoOSITCTT-Bold' }}>BodoniSvtyTwoOSITCTT-Bold </option>

            <option value='BodoniSvtyTwoOSITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoOSITCTT-Book' }}>BodoniSvtyTwoOSITCTT-Book </option>

            <option value='BodoniSvtyTwoSCITCTT-Book' style={{ fontFamily: 'BodoniSvtyTwoSCITCTT-Book' }}>BodoniSvtyTwoSCITCTT-Book </option>

            <option value='Bradley Hand' style={{ fontFamily: 'Bradley Hand' }}>Bradley Hand </option>

            <option value='BradleyHandITCTT-Bold' style={{ fontFamily: 'BradleyHandITCTT-Bold' }}>BradleyHandITCTT-Bold </option>

            <option value='Chalkboard SE' style={{ fontFamily: 'Chalkboard SE' }}>Chalkboard SE </option>

            <option value='ChalkboardSE-Bold' style={{ fontFamily: 'ChalkboardSE-Bold' }}>ChalkboardSE-Bold </option>

            <option value='ChalkboardSE-Light' style={{ fontFamily: 'ChalkboardSE-Light' }}>ChalkboardSE-Light </option>

            <option value='ChalkboardSE-Regular' style={{ fontFamily: 'ChalkboardSE-Regular' }}>ChalkboardSE-Regular </option>

            <option value='Chalkduster' style={{ fontFamily: 'Chalkduster' }}>Chalkduster </option>



            <option value='Copperplate' style={{ fontFamily: 'Copperplate' }}>Copperplate </option>

            <option value='Copperplate-Bold' style={{ fontFamily: 'Copperplate-Bold' }}>Copperplate-Bold </option>

            <option value='Copperplate-Light' style={{ fontFamily: 'Copperplate-Light' }}>Copperplate-Light </option>

            <option value='Courier' style={{ fontFamily: 'Courier' }}>Courier </option>

            <option value='Courier New' style={{ fontFamily: 'Courier New' }}>Courier New </option>

            <option value='Courier Bold' style={{ fontFamily: 'Courier-Bold' }}>Courier-Bold </option>

            <option value='Courier-BoldOblique' style={{ fontFamily: 'Courier-BoldOblique' }}>Courier-BoldOblique </option>

            <option value='Courier-Oblique' style={{ fontFamily: 'Courier-Oblique' }}>Courier-Oblique </option>

            <option value='CourierNewPS-BoldItalicMT' style={{ fontFamily: 'CourierNewPS-BoldItalicMT' }}>CourierNewPS-BoldItalicMT </option>

            <option value='CourierNewPS-BoldMT' style={{ fontFamily: 'CourierNewPS-BoldMT' }}>CourierNewPS-BoldMT </option>

            <option value='CourierNewPS-ItalicMT' style={{ fontFamily: 'CourierNewPS-ItalicMT' }}>CourierNewPS-ItalicMT </option>

            <option value='CourierNewPSMT' style={{ fontFamily: 'CourierNewPSMT' }}>CourierNewPSMT </option>

            <option value='Cursive' style={{ fontFamily: 'Cursive' }}>Cursive </option>

            <option value='Damascus' style={{ fontFamily: 'Damascus' }}>Damascus </option>

            <option value='DamascusBold' style={{ fontFamily: 'DamascusBold' }}>DamascusBold </option>

            <option value='DamascusLight' style={{ fontFamily: 'DamascusLight' }}>DamascusLight </option>

            <option value='DamascusMedium' style={{ fontFamily: 'DamascusMedium' }}>DamascusMedium </option>

            <option value='DamascusSemiBold' style={{ fontFamily: 'DamascusSemiBold' }}>DamascusSemiBold </option>



            <option value='Didot' style={{ fontFamily: 'Didot' }}>Didot </option>

            <option value='Didot-Bold' style={{ fontFamily: 'Didot-Bold' }}>Didot-Bold </option>

            <option value='Didot-Italic' style={{ fontFamily: 'Didot-Italic' }}>Didot-Italic </option>

            <option value='DiwanMishafi' style={{ fontFamily: 'DiwanMishafi' }}>DiwanMishafi </option>

            <option value='Euphemia UCAS' style={{ fontFamily: 'Euphemia UCAS' }}>Euphemia UCAS </option>

            <option value='EuphemiaUCAS-Bold' style={{ fontFamily: 'EuphemiaUCAS-Bold' }}>EuphemiaUCAS-Bold </option>

            <option value='EuphemiaUCAS-Italic' style={{ fontFamily: 'EuphemiaUCAS-Italic' }}>EuphemiaUCAS-Italic </option>

            <option value='Farah' style={{ fontFamily: 'Farah' }}>Farah </option>

            <option value='Futura' style={{ fontFamily: 'Futura' }}>Futura </option>

            <option value='Futura-CondensedExtraBold' style={{ fontFamily: 'Futura-CondensedExtraBold' }}>Futura-CondensedExtraBold </option>

            <option value='Futura-CondensedMedium' style={{ fontFamily: 'Futura-CondensedMedium' }}>Futura-CondensedMedium </option>

            <option value='Futura-Medium' style={{ fontFamily: 'Futura-Medium' }}>Futura-Medium </option>

            <option value='Futura-MediumItalic' style={{ fontFamily: 'Futura-MediumItalic' }}>Futura-MediumItalic </option>

            <option value='GeezaPro Pro' style={{ fontFamily: 'Geeza Pro' }}>Geeza Pro </option>

            <option value='GeezaPro-Bold' style={{ fontFamily: 'GeezaPro-Bold' }}>GeezaPro-Bold </option>

            <option value='Georgia' style={{ fontFamily: 'Georgia' }}>Georgia </option>

            <option value='Georgia-Bold' style={{ fontFamily: 'Georgia-Bold' }}>Georgia-Bold </option>

            <option value='Georgia-BoldItalic' style={{ fontFamily: 'Georgia-BoldItalic' }}>Georgia-BoldItalic </option>

            <option value='Georgia-Italic' style={{ fontFamily: 'Georgia-Italic' }}>Georgia-Italic </option>

            <option value='Gill Sans' style={{ fontFamily: 'Gill Sans' }}>Gill Sans </option>

            <option value='GillSans-Bold' style={{ fontFamily: 'GillSans-Bold' }}>GillSans-Bold </option>

            <option value='GillSans-BoldItalic' style={{ fontFamily: 'GillSans-BoldItalic' }}>GillSans-BoldItalic </option>

            <option value='GillSans-Italic' style={{ fontFamily: 'GillSans-Italic' }}>GillSans-Italic </option>

            <option value='GillSans-Light' style={{ fontFamily: 'GillSans-Light' }}>GillSans-Light </option>

            <option value='GillSans-LightItalic' style={{ fontFamily: 'GillSans-LightItalic' }}>GillSans-LightItalic </option>

            <option value='GillSans-SemiBold' style={{ fontFamily: 'GillSans-SemiBold' }}>GillSans-SemiBold </option>

            <option value='GillSans-SemiBoldItalic' style={{ fontFamily: 'GillSans-SemiBoldItalic' }}>GillSans-SemiBoldItalic </option>

            <option value='GillSans-UltraBold' style={{ fontFamily: 'GillSans-UltraBold' }}>GillSans-UltraBold </option>


            <option value='Heiti SC' style={{ fontFamily: 'Heiti SC' }}>Heiti SC </option>

            <option value='Heiti TC' style={{ fontFamily: 'Heiti TC' }}>Heiti TC </option>

            <option value='Helvetica' style={{ fontFamily: 'Helvetica' }}>Helvetica </option>

            <option value='Helvetica Neue' style={{ fontFamily: 'Helvetica Neue' }}>Helvetica Neue </option>

            <option value='Helvetica-Bold' style={{ fontFamily: 'Helvetica-Bold' }}>Helvetica-Bold </option>

            <option value='Helvetica-BoldOblique' style={{ fontFamily: 'Helvetica-BoldOblique' }}>Helvetica-BoldOblique </option>

            <option value='Helvetica-Light' style={{ fontFamily: 'Helvetica-Light' }}>Helvetica-Light </option>

            <option value='Helvetica-LightOblique' style={{ fontFamily: 'Helvetica-LightOblique' }}>Helvetica-LightOblique </option>

            <option value='Helvetica-Oblique' style={{ fontFamily: 'Helvetica-Oblique' }}>Helvetica-Oblique </option>

            <option value='HelveticaNeue-Bold' style={{ fontFamily: 'HelveticaNeue-Bold' }}>HelveticaNeue-Bold </option>

            <option value='HelveticaNeue-BoldItalic' style={{ fontFamily: 'HelveticaNeue-BoldItalic' }}>HelveticaNeue-BoldItalic </option>

            <option value='HelveticaNeue-CondensedBlack' style={{ fontFamily: 'HelveticaNeue-CondensedBlack' }}>HelveticaNeue-CondensedBlack </option>

            <option value='HelveticaNeue-CondensedBold' style={{ fontFamily: 'HelveticaNeue-CondensedBold' }}>HelveticaNeue-CondensedBold </option>

            <option value='HelveticaNeue-Italic' style={{ fontFamily: 'HelveticaNeue-Italic' }}>HelveticaNeue-Italic </option>

            <option value='HelveticaNeue-Light' style={{ fontFamily: 'HelveticaNeue-Light' }}>HelveticaNeue-Light </option>

            <option value='HelveticaNeue-LightItalic' style={{ fontFamily: 'HelveticaNeue-LightItalic' }}>HelveticaNeue-LightItalic </option>

            <option value='HelveticaNeue-Medium' style={{ fontFamily: 'HelveticaNeue-Medium' }}>HelveticaNeue-Medium </option>

            <option value='HelveticaNeue-MediumItalic' style={{ fontFamily: 'HelveticaNeue-MediumItalic' }}>HelveticaNeue-MediumItalic </option>

            <option value='HelveticaNeue-Thin' style={{ fontFamily: 'HelveticaNeue-Thin' }}>HelveticaNeue-Thin </option>

            <option value='HelveticaNeue-ThinItalic' style={{ fontFamily: 'HelveticaNeue-ThinItalic' }}>HelveticaNeue-ThinItalic </option>

            <option value='HelveticaNeue-UltraLight' style={{ fontFamily: 'HelveticaNeue-UltraLight' }}>HelveticaNeue-UltraLight </option>

            <option value='HelveticaNeue-UltraLightItalic' style={{ fontFamily: 'HelveticaNeue-UltraLightItalic' }}>HelveticaNeue-UltraLightItalic </option>

            <option value='Hiragino Mincho ProN' style={{ fontFamily: 'Hiragino Mincho ProN' }}>Hiragino Mincho ProN </option>

            <option value='Hiragino Sans' style={{ fontFamily: 'Hiragino Sans' }}>Hiragino Sans </option>

            <option value='HiraginoSans-W3' style={{ fontFamily: 'HiraginoSans-W3' }}>HiraginoSans-W3 </option>

            <option value='HiraginoSans-W6' style={{ fontFamily: 'HiraginoSans-W6' }}>HiraginoSans-W6 </option>

            <option value='HiraMinProN-W3' style={{ fontFamily: 'HiraMinProN-W3' }}>HiraMinProN-W3 </option>

            <option value='HiraMinProN-W6' style={{ fontFamily: 'HiraMinProN-W6' }}>HiraMinProN-W6 </option>

            <option value='Hoefler Text' style={{ fontFamily: 'Hoefler Text' }}>Hoefler Text </option>

            <option value='HoeflerText-Black' style={{ fontFamily: 'HoeflerText-Black' }}>HoeflerText-Black </option>

            <option value='HoeflerText-BlackItalic' style={{ fontFamily: 'HoeflerText-BlackItalic' }}>HoeflerText-BlackItalic </option>

            <option value='HoeflerText-Italic' style={{ fontFamily: 'HoeflerText-Italic' }}>HoeflerText-Italic </option>

            <option value='HoeflerText-Regular' style={{ fontFamily: 'HoeflerText-Regular' }}>HoeflerText-Regular </option>

            <option value="'Jakarta',sans-serif" style={{ fontFamily: 'Jakarta' }}>Jakarta </option>

            <option value='Kailasa' style={{ fontFamily: 'Kailasa' }}>Kailasa </option>

            <option value='Kailasa-Bold' style={{ fontFamily: 'Kailasa-Bold' }}>Kailasa-Bold </option>


            <option value='Khmer Sangam MN' style={{ fontFamily: 'Khmer Sangam MN' }}>Khmer Sangam MN </option>


            <option value='Lao Sangam MN' style={{ fontFamily: 'Lao Sangam MN' }}>Lao Sangam MN </option>


            <option value='Marker Felt' style={{ fontFamily: 'Marker Felt' }}>Marker Felt </option>

            <option value='MarkerFelt-Thin' style={{ fontFamily: 'MarkerFelt-Thin' }}>MarkerFelt-Thin </option>

            <option value='MarkerFelt-Wide' style={{ fontFamily: 'MarkerFelt-Wide' }}>MarkerFelt-Wide </option>

            <option value='Menlo' style={{ fontFamily: 'Menlo' }}>Menlo </option>

            <option value='Menlo-Bold' style={{ fontFamily: 'Menlo-Bold' }}>Menlo-Bold </option>

            <option value='Menlo-BoldItalic' style={{ fontFamily: 'Menlo-BoldItalic' }}>Menlo-BoldItalic </option>

            <option value='Menlo-Italic' style={{ fontFamily: 'Menlo-Italic' }}>Menlo-Italic </option>

            <option value='Menlo-Regular' style={{ fontFamily: 'Menlo-Regular' }}>Menlo-Regular </option>

            <option value='Mishafi' style={{ fontFamily: 'Mishafi' }}>Mishafi </option>

            <option value='Noteworthy' style={{ fontFamily: 'Noteworthy' }}>Noteworthy </option>

            <option value='Noteworthy-Bold' style={{ fontFamily: 'Noteworthy-Bold' }}>Noteworthy-Bold </option>

            <option value='Noteworthy-Light' style={{ fontFamily: 'Noteworthy-Light' }}>Noteworthy-Light </option>

            <option value='Optima' style={{ fontFamily: 'Optima' }}>Optima </option>

            <option value='Optima-Bold' style={{ fontFamily: 'Optima-Bold' }}>Optima-Bold </option>

            <option value='Optima-BoldItalic' style={{ fontFamily: 'Optima-BoldItalic' }}>Optima-BoldItalic </option>

            <option value='Optima-ExtraBlack' style={{ fontFamily: 'Optima-ExtraBlack' }}>Optima-ExtraBlack </option>

            <option value='Optima-Italic' style={{ fontFamily: 'Optima-Italic' }}>Optima-Italic </option>

            <option value='Optima-Regular' style={{ fontFamily: 'Optima-Regular' }}>Optima-Regular </option>


            <option value='Palatino' style={{ fontFamily: 'Palatino' }}>Palatino </option>

            <option value='Palatino-Bold' style={{ fontFamily: 'Palatino-Bold' }}>Palatino-Bold </option>

            <option value='Palatino-BoldItalic' style={{ fontFamily: 'Palatino-BoldItalic' }}>Palatino-BoldItalic </option>

            <option value='Palatino-Italic' style={{ fontFamily: 'Palatino-Italic' }}>Palatino-Italic </option>

            <option value='Palatino-Roman' style={{ fontFamily: 'Palatino-Roman' }}>Palatino-Roman </option>

            <option value='Papyrus' style={{ fontFamily: 'Papyrus' }}>Papyrus </option>

            <option value='Papyrus-Condensed' style={{ fontFamily: 'Papyrus-Condensed' }}>Papyrus-Condensed </option>

            <option value='Party LET' style={{ fontFamily: 'Party LET' }}>Party LET </option>

            <option value='PartyLetPlain' style={{ fontFamily: 'PartyLetPlain' }}>PartyLetPlain </option>





            <option value='Savoye LET' style={{ fontFamily: 'Savoye LET' }}>Savoye LET </option>

            <option value='SavoyeLetPlain' style={{ fontFamily: 'SavoyeLetPlain' }}>SavoyeLetPlain </option>

            <option value='Sinhala Sangam MN' style={{ fontFamily: 'Sinhala Sangam MN' }}>Sinhala Sangam MN </option>

            <option value='SinhalaSangamMN' style={{ fontFamily: 'SinhalaSangamMN' }}>SinhalaSangamMN </option>

            <option value='SinhalaSangamMN-Bold' style={{ fontFamily: 'SinhalaSangamMN-Bold' }}>SinhalaSangamMN-Bold </option>

            <option value='Snell Roundhand' style={{ fontFamily: 'Snell Roundhand' }}>Snell Roundhand </option>

            <option value='SnellRoundhand-Black' style={{ fontFamily: 'SnellRoundhand-Black' }}>SnellRoundhand-Black </option>

            <option value='SnellRoundhand-Bold' style={{ fontFamily: 'SnellRoundhand-Bold' }}>SnellRoundhand-Bold </option>

            <option value='Symbol' style={{ fontFamily: 'Symbol' }}>Symbol </option>


            <option value='Thonburi' style={{ fontFamily: 'Thonburi' }}>Thonburi </option>

            <option value='Thonburi-Bold' style={{ fontFamily: 'Thonburi-Bold' }}>Thonburi-Bold </option>

            <option value='Thonburi-Light' style={{ fontFamily: 'Thonburi-Light' }}>Thonburi-Light </option>

            <option value='Times New Roman' style={{ fontFamily: 'Times New Roman' }}>Times New Roman </option>

            <option value='TimesNewRomanPS-BoldItalicMT' style={{ fontFamily: 'TimesNewRomanPS-BoldItalicMT' }}>TimesNewRomanPS-BoldItalicMT </option>

            <option value='TimesNewRomanPS-BoldMT' style={{ fontFamily: 'TimesNewRomanPS-BoldMT' }}>TimesNewRomanPS-BoldMT </option>

            <option value='TimesNewRomanPS-ItalicMT' style={{ fontFamily: 'TimesNewRomanPS-ItalicMT' }}>TimesNewRomanPS-ItalicMT </option>

            <option value='TimesNewRomanPSMT' style={{ fontFamily: 'TimesNewRomanPSMT' }}>TimesNewRomanPSMT </option>

            <option value='Trebuchet MS' style={{ fontFamily: 'Trebuchet MS' }}>Trebuchet MS </option>

            <option value='Trebuchet-BoldItalic' style={{ fontFamily: 'Trebuchet-BoldItalic' }}>Trebuchet-BoldItalic </option>

            <option value='TrebuchetMS-Bold' style={{ fontFamily: 'TrebuchetMS-Bold' }}>TrebuchetMS-Bold </option>

            <option value='TrebuchetMS-Italic' style={{ fontFamily: 'TrebuchetMS-Italic' }}>TrebuchetMS-Italic </option>

            <option value='Verdana' style={{ fontFamily: 'Verdana' }}>Verdana </option>

            <option value='Verdana-Bold' style={{ fontFamily: 'Verdana-Bold' }}>Verdana-Bold </option>

            <option value='Verdana-BoldItalic' style={{ fontFamily: 'Verdana-BoldItalic' }}>Verdana-BoldItalic </option>

            <option value='Verdana-Italic' style={{ fontFamily: 'Verdana-Italic' }}>Verdana-Italic </option>

            <option value='Zapf Dingbats' style={{ fontFamily: 'Zapf Dingbats' }}>Zapf Dingbats </option>

            <option value='ZapfDingbatsITC' style={{ fontFamily: 'ZapfDingbatsITC' }}>ZapfDingbatsITC </option>

            <option value='Zapfino' style={{ fontFamily: 'Zapfino' }}>Zapfino </option>
            {botSettings.customFonts !== undefined && botSettings.customFonts.length > 0 && botSettings.customFonts.map((m) => {
                return (
                    <option value={m.fontName} style={{ fontFamily: `${m.fontName}` }}>{m.fontName} </option>
                );
            })}

        </select>
    </div>);
}